import { render, staticRenderFns } from "./PricePage.vue?vue&type=template&id=0eb4f3a9&scoped=true&"
import script from "./PricePage.vue?vue&type=script&lang=js&"
export * from "./PricePage.vue?vue&type=script&lang=js&"
import style0 from "./PricePage.vue?vue&type=style&index=0&id=0eb4f3a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb4f3a9",
  null
  
)

export default component.exports